// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading_loadingWrapper__1vF3j","spinnerPosition":"loading_spinnerPosition__sxaMf"};